import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbsenceReasonsResponse } from '../models/absence-reasons-response.interface';
import { Document } from '../models/document.interface';
import { UploadDocumentResponse } from '../models/upload-document.interface';
import { environment } from 'src/environments/environment';
import { AbsenceJustificationResponse } from '../models/absence-justification-response.interface';
import { AbsencePreAdviceResponse } from '../models/absence-pre-advice-response.interface';
import { AbsenceJustificationRequest } from '../models/absence-justification-request';
import { AbsencePreAdviceRequest } from '../models/absence-pre-advice-request.interface';

@Injectable({
  providedIn: 'root',
})
export class AusenciasService {
  constructor(private http: HttpClient) {}

  getAbsenceJustification(token: string): Observable<AbsenceJustificationResponse> {
    const params = new HttpParams().set('token', token);
    return this.http.get<AbsenceJustificationResponse>(
      `${environment.apiurl}/api/v1.0/attendance/issue/external/absence`,
      { params: params }
    );
  }

  getAbsencePreAdvice(token: string): Observable<AbsencePreAdviceResponse> {
    const params = new HttpParams().set('token', token);
    return this.http.get<AbsencePreAdviceResponse>(
      `${environment.apiurl}/api/v1.0/attendance/issue/external/pre-advice`,
      { params: params }
    );
  }

  getAbsenceReasons(
    countryCode: string,
    absenceType: string
  ): Observable<AbsenceReasonsResponse> {
    const isRRHH = sessionStorage.getItem('isRRHH')! === "true";
    return this.http.get<AbsenceReasonsResponse>(
      `${environment.apiurl}/api/v1.0/attendance/parametric/external/absence-reasons/${countryCode}/${absenceType}/${isRRHH}`
    );
  }

  uploadDocument(document: FormData): Observable<UploadDocumentResponse> {
    const token = sessionStorage.getItem('token')!;
    const params = new HttpParams().set('token', token);
    return this.http.post<UploadDocumentResponse>(
      `${environment.apiurl}/api/v1.0/attendance/document/external`,
      document,
      { params: params }
    );
  }

  removeDocument(document: Document): Observable<void> {
    const token = sessionStorage.getItem('token')!;
    const params = new HttpParams().set('token', token);
    return this.http.delete<void>(
      `${environment.apiurl}/api/v1.0/attendance/document/external/${document.id}`,
      { params: params }
    );
  }

  downLoadDocument(document: Document): Observable<any> {
    const token = sessionStorage.getItem('token')!;
    const params = new HttpParams().set('token', token);
    return this.http.get<any>(
      `${environment.apiurl}/api/v1.0/attendance/document/external/${document.id}`,
      { params: params, responseType: 'blob' as 'json' }
    );
  }

  sendAbsenceJustification(absence: AbsenceJustificationRequest): Observable<void> {
    const token = sessionStorage.getItem('token')!;
    const params = new HttpParams().set('token', token);
    return this.http.post<void>(
      `${environment.apiurl}/api/v1.0/attendance/issue/external/absence/submit`,
      absence,
      { params: params }
    );
  }

  sendAbsencePreAdvice(absencePreAdvice: AbsencePreAdviceRequest): Observable<void> {
    const token = sessionStorage.getItem('token')!;
    const params = new HttpParams().set('token', token);
    return this.http.post<void>(
      `${environment.apiurl}/api/v1.0/attendance/issue/external/pre-advice/submit`,
      absencePreAdvice,
      { params: params }
    );
  }
}
